export class FtError extends Error {
}
